import * as React from 'react'

import Box from '@mui/material/Box'
import { MultiSelect } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { BestContactTimeOptionsType } from './hooks/useData'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  required: boolean
  show: boolean
  showCheckBox?: boolean
  name: string
  density: DensityType
}

export function BestContactTimeSelect(props: Props) {
  const { required, show, name, density, showCheckBox } = props
  const {
    options,
    getOptionLabel,
    getId,
    initialOption,
    isSubmitting,
    helperText,
    showError,
  } = useData({ required, name })
  const { handelChange } = useHandlers()

  return show ? (
    <Box>
      <MultiSelect<BestContactTimeOptionsType>
        density={density}
        disabled={isSubmitting}
        required={required}
        getLabel={getOptionLabel}
        getId={getId}
        items={options}
        onChange={handelChange}
        error={showError}
        hideCheckbox={!showCheckBox}
        value={initialOption}
        label={'Best Contact Time(s)'}
        optionMode={'normal'}
        inputMode="normal"
        maxSelectedItemsToShow={4}
        maxSelectedItemsToShowOnFocus={4}
        placeholder="Search Best Contact Time(s)"
        testId="best-contact-time-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
